// extracted by css-extract-rspack-plugin
export default {"root":"root-j9lIbF","header":"header-uLJMGp","name":"name-zyP54J","description":"description-sL0V8S text-sm"};